<template>
  <section class="section-contacttUs">
    <div class="container">
      <div class="section-space-50"></div>

      <div class="row">
        <div class="col-lg-8 mb-3 mb-md-0">
          <div class="section-header-title">Contact Us</div>
          <template v-if="contact_us_html">
            <div v-html="contact_us_html"></div>
          </template>
          <template v-else>
            <p class="my-4 my-md-5">
              Hey! We love working on ourselves, so if you have a suggestion or any feedback please write to us:	
            </p>
          </template>
          <div>
            <h5 class="font-weight-bold">Registered Office Address</h5>

            <p>
              Miraj Campus , Nathdwara, Rajsamand,Rajasthan-313301, India
            </p>
          </div>
          <div>
            <h5 class="font-weight-bold">Corporate Office Address</h5>

            <p>
              Miraj Entertainment Limited 3rd Floor, Acme Plaza-2, <br />
              Near Chakala Metro Station, Andheri - Kurla Road, <br />
              Andheri East, Mumbai - 400059
            </p>
          </div>
          
          <div class="row mt-3">
            <div class="col-md-6 mb-3 mb-md-4">
              <h5 class="font-weight-bold">For Sales</h5>
              <ul class="list-inline pl-3">
                <li class="mob-fs-14">
                  <img
                    src="@/assets/img/icons/emailIcon.svg"
                    class="mr-2"
                    alt
                  />
                  <!-- adsales@mirajcinemas.com -->
                   <template v-if="customer_care_email">
                    {{ plainEmail }}
                  </template>
                  <template v-else>
                    <span>contactus@mirajcinemas.com</span>
                  </template>
                </li>
              </ul>
            </div>
            <div class="col-md-6 mb-3 mb-md-4">
              <h5 class="font-weight-bold">For Sponsorships/Partnerships</h5>
              <ul class="list-inline pl-3">
                <li class="mob-fs-14">
                  <img
                    src="@/assets/img/icons/emailIcon.svg"
                    class="mr-2"
                    alt
                  />
                  <!-- marketing@mirajcinemas.com -->
                   <template v-if="customer_care_email">
                    {{ plainEmail }}
                  </template>
                  <template v-else>
                    <span>contactus@mirajcinemas.com</span>
                  </template>
                </li>
              </ul>
            </div>
            <div class="col-md-6 mb-3 mb-md-4">
              <h5 class="font-weight-bold">For HR</h5>
              <ul class="list-inline pl-3">
                <li class="mob-fs-14">
                  <img
                    src="@/assets/img/icons/emailIcon.svg"
                    class="mr-2"
                    alt
                  />
                  <!-- hohr@mirajcinemas.com -->
                   <template v-if="customer_care_email">
                    {{ plainEmail }}
                  </template>
                  <template v-else>
                    <span>contactus@mirajcinemas.com</span>
                  </template>
                </li>
              </ul>
            </div>
            <div class="col-md-6 mb-3 mb-md-4">
              <h5 class="font-weight-bold">For Bulkbookings</h5>
              <ul class="list-inline pl-3">
                <li class="mob-fs-14">
                  <img
                    src="@/assets/img/icons/emailIcon.svg"
                    class="mr-2"
                    alt
                  />
                  <!-- bulkbooking@mirajcinemas.com -->
                   <template v-if="customer_care_email">
                    {{ plainEmail }}
                  </template>
                  <template v-else>
                    <span>contactus@mirajcinemas.com</span>
                  </template>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="col-lg-4">
          <div class="feedbackForm py-4 px-3 px-md-4">
            <h5 class="mb-4 font-weight-bold">Feedback Form</h5>
            <form @submit.stop.prevent="handleSubmit()">
              <div class="mb-3">
                <p class="mb-1">
                  Name
                  <span class="text-danger">*</span>
                </p>
                <div>
                  <input
                    type="search"
                    placeholder="Name"
                    class="form-control"
                    v-model="name"
                    required
                  />
                </div>
              </div>

              <div class="mb-3">
                <p class="mb-1">
                  Email Address
                  <span class="text-danger">*</span>
                </p>
                <input
                  placeholder="Email Address"
                  type="email"
                  class="form-control"
                  v-model="email"
                  required
                  ref="emailAddress"
                />
                <p class="text-danger" v-if="errorEmail">{{errorEmail}}</p>
              </div>

              <div class="mb-3">
                <p class="mb-1">
                  Contact No.
                  <span class="text-danger">*</span>
                </p>
                <input
                  placeholder="Mobile Number"
                  type="number"
                  maxlength="10"
                  ref="contactNumber"
                  onkeyup="this.value=this.value.replace(/[^0-9]+/g,'');"
                  onkeypress="if(this.value.length==10) return false;"
                  class="form-control"
                  v-model="mobile"
                  required
                />
                <p class="text-danger" v-if="errorMobile">{{errorMobile}}</p>
              </div>

              <div class="mb-3">
                <p class="mb-1">
                  City
                  <span class="text-danger">*</span>
                </p>
                <b-dropdown
                  no-caret
                  variant="transparent"
                  class="
                    w-100
                    border
                    rounded
                    text-left
                    dd-menu-100
                    scroll-dropdown
                  "
                >
                  <template v-slot:button-content>
                    <div class="text-left">
                      {{ city_name ? city_name : "Select City" }}
                    </div>
                  </template>
                  <b-dropdown-item
                    v-for="city of cities"
                    :key="city.city_id"
                    @click="
                      (e) => {
                        Cinema_strName = null;
                        city_id = city.city_id;
                        city_name = city.city_name;
                        getCinemaNames(city.city_id)
                      }
                    "
                    >{{ city.city_name }}</b-dropdown-item
                  >
                </b-dropdown>
              </div>
              <div class="mb-3">
                <p class="mb-1">
                  Cinema
                  <span class="text-danger">*</span>
                </p>
                <b-dropdown
                  no-caret
                  variant="transparent"
                  class="
                    w-100
                    border
                    rounded
                    text-left
                    dd-menu-100
                    scroll-dropdown
                  "
                >
                  <template v-slot:button-content>
                    <div class="text-left">
                      {{ Cinema_strName ? Cinema_strName : "Select Cinema" }}
                    </div>
                  </template>
                  <b-dropdown-item
                    v-for="(cinema, cinema_key) in cinema_names"
                    :key="cinema_key + 'cinema_key'"
                    @click="
                      (e) => {
                        Cinema_strName = cinema.Cinema_strName;
                      }
                    "
                    >{{ cinema.Cinema_strName }}</b-dropdown-item
                  >
                </b-dropdown>
                <p class="text-danger" v-if="errorCinema">{{errorCinema}}</p>
              </div>

              <div class="mb-3">
                <p class="mb-1">
                  Show Date
                  <!-- <span class="text-danger">*</span> -->
                </p>
                <input
                  placeholder="Show Date"
                  type="date"
                  class="form-control"
                  v-model="show_date"
                  style="color-scheme: dark"
                />
              </div>

              <div class="mb-3">
                <p class="mb-1">
                  Comment/ Message
                  <span class="text-danger">*</span>
                </p>
                <textarea
                  placeholder=""
                  name
                  id
                  cols="30"
                  class="form-control"
                  rows="6"
                  v-model="message"
                  required
                ></textarea>
              </div>
              <div class="text-center text-left">
                <button class="btn btn-primary mt-4 px-5" type="submit">
                  SUBMIT
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="section-space-50"></div>
    </div>
    <b-modal
      ref="alertPopup"
      id="alertPopup"
      title="Request submitted"
      hide-footer
    >
      <div>
        <div class="p-3">
          <div class="col-12 col-sm-12 col-md-11 col-lg-11 col-xl-11 mx-auto">
            <div class="row my-4">
              <div class="col-12 text-center">
                <img src="@/assets/img/icons/check-icon.svg" alt="Success" />
              </div>
              <div class="col-12 text-center my-4">
                <p>
                  Your request for Feedback has submitted successfully.
                  <br />We will get in touch with you soon!
                </p>
              </div>
              <div class="col-12">
                <button
                  class="btn btn-primary w-100"
                  @click="$bvModal.hide('alertPopup')"
                >
                  DONE
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </section>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
import ExtrasServices from "@/apiServices/ExtrasService";
import LocationService from "@/apiServices/LocationService";

export default {
  data() {
    return {
      contact_us_html: null,

      aboutUsSlider: {
        dots: false,
        arrows: true,
        slidesToShow: 1,
      },

      name: null,
      email: null,
      mobile: null,
      city_name: null,
      city_id: null,
      Cinema_strName: null,
      show_date: null,

      cities: [],
      cinema_names: [],
      category: null,
      message: null,
      errorMobile: null,
      errorCinema: null,
      errorEmail: null,
      customer_care_email: null,
    };
  },
  beforeMount() {
    if (this.getIsUserLogged) {
      this.email = this.getLoggedUser.user_email;
    }
    this.city_id = localStorage.getItem('city_id');
    this.getCities();
    this.getCinemaNames();
    this.getContactUsHtml();
    this.getCustomerCareEmail();
  },
  computed: {
    ...mapGetters(["getLoggedUser", "getIsUserLogged"]),
    plainEmail() {
      const temp = document.createElement('div');
      temp.innerHTML = this.customer_care_email;
      const link = temp.querySelector('a');
      return link ? link.textContent.trim() : '';
    }
  },
  methods: {
    async getContactUsHtml() {
      try {
        const response = await ExtrasServices.getContactUs();
        console.log({ response });
        if (response.data.status) {
          this.contact_us_html = response.data.data.extra_html_content;
          // console.log("Contact us data", this.contact_us_html);
        }
      } catch (err) {
        console.log("Error in getting contact us html ", err);
      }
    },
    async getCities() {
      const { data } = await LocationService.GetCities();
      if (data && data.status) {
        this.cities = data.data;
        const cityName = this.getCityNameById(this.city_id);
        this.city_name = cityName
      }
    },
    getCityNameById(id) {
        const city = this.cities.filter(city => {
          return city.city_id === parseInt(id)
        });
        return city && city[0] ? city[0].city_name : undefined;
    },
    async getCinemaNames(params={}) {
      const { data } = await ExtrasServices.getCinemaNames({city_id:this.city_id});
      // console.log({ data });
      if (data && data.status) {
        this.cinema_names = data.data;
      }
    },
    async getCustomerCareEmail() {
      try {
        const response = await ExtrasServices.getCustomerCareEmail();
        if (response.data.status) {
          this.customer_care_email = response.data.data.extra_html_content;
        }
      } catch (err) {
        console.log("Error in getting customer care email ", err);
      }
    },
    async handleSubmit(e) {
      this.errorCinema = null;
      this.errorMobile = null;
      this.errorEmail = null;
      if(!this.Cinema_strName){
        this.errorCinema = "Please select cinema";
        return false;
      }
      if(String(this.mobile).length !== 10 || /(\d)\1{9}/.test(this.mobile)){
        this.errorMobile = "Enter Valid Mobile No.";
        this.$nextTick(() => {
          this.$refs.contactNumber.focus();
        });
        return false;
      }
      if (!this.email || !/\S+@\S+\.\S+/.test(this.email)) {
        this.errorEmail = "Enter Valid Email Address";
        this.$nextTick(() => {
          this.$refs.emailAddress.focus();
        });
        return false;
      }
      // e.preventDefault();
      const payload = {
        category: this.category,
        email: this.email,
        message: this.message,
        name: this.name,
        mobile: this.mobile,
        city_name: this.city_name,
        Cinema_strName: this.Cinema_strName,
        show_date: this.show_date,
      };

      try {
        const response = await ExtrasServices.contactUs(payload);
        if (response.data.status) {
          // alert('Form Submitted');
        }
      } catch (err) {
        console.log("Error in contactUs  ", err);
      }

      this.errorCinema = null;
      this.errorMobile = null;
      this.$bvModal.show("alertPopup");
      this.email = null;
      this.message = null;
      this.category = null;
    },
  },
};
</script>
<style scoped>
.section-contacttUs .btn-transparent .text-left {
 color: white !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/contactUs.vue